export type JudgeStatusType =
  | 'COMPILEERROR'
  | 'WRONGANSWER'
  | 'TIMELIMIT'
  | 'MEMORYLIMIT'
  | 'ACCEPTED'
  | 'WAITING'
  | 'OUTPUTLIMIT'
  | 'RUNTIMEERROR'
  | 'PRESENTATIONERROR'
  | 'RUNNING'
  | 'NODATA'

export const convertJudgeStatusType = (x: number | string): JudgeStatusType => {
  switch (x) {
    case 0:
    case 'CE':
      return 'COMPILEERROR'
    case 1:
    case 'WA':
      return 'WRONGANSWER'
    case 2:
    case 'TLE':
      return 'TIMELIMIT'
    case 3:
    case 'MLE':
      return 'MEMORYLIMIT'
    case 4:
    case 'AC':
      return 'ACCEPTED'
    case 5:
      return 'WAITING'
    case 6:
    case 'OLE':
      return 'OUTPUTLIMIT'
    case 7:
    case 'RE':
      return 'RUNTIMEERROR'
    case 8:
    case 'PE':
      return 'PRESENTATIONERROR'
    case 9:
      return 'RUNNING'
    default:
      return 'NODATA'
  }
}

export const convertJudgeStatusKey = (x: JudgeStatusType | string): string => {
  switch (x) {
    case 'COMPILEERROR':
      return 'CE'
    case 'WRONGANSWER':
      return 'WA'
    case 'TIMELIMIT':
      return 'TLE'
    case 'MEMORYLIMIT':
      return 'MLE'
    case 'ACCEPTED':
      return 'AC'
    case 'OUTPUTLIMIT':
      return 'OLE'
    case 'RUNTIMEERROR':
      return 'RE'
    case 'PRESENTATIONERROR':
      return 'PE'
    default:
      return 'WA'
  }
}
